// Client V2 common imports
const { DISMISS_OPEN_IN_APP } = require('client-v2/common/containers/open-in-app-button/actions')
// Sibling imports
const EnvironmentRecord = require('./record')

function envReducer(state = new EnvironmentRecord(), action) {
  switch (action.type) {
    case DISMISS_OPEN_IN_APP:
      return state.set('openInAppDismissed', true)
    default:
      return state
  }
}

module.exports = envReducer
